import { render, staticRenderFns } from "./AgentBuy.vue?vue&type=template&id=3e84a8e6&scoped=true&"
import script from "./AgentBuy.vue?vue&type=script&lang=js&"
export * from "./AgentBuy.vue?vue&type=script&lang=js&"
import style0 from "./AgentBuy.vue?vue&type=style&index=0&id=3e84a8e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e84a8e6",
  null
  
)

export default component.exports